import React, { useState, useEffect, useCallback } from "react";
import Menubar from "../../../../components/WhrManager/App";
import { http } from "../../../../services/http";
import InventoryTransfersModal from "../../../../components/WhrManager/InventoryTransfersModal";
import { useTranslation } from "react-i18next";
import Header from "../../../../components/header";
import moment from "moment";
import { debouncedSet } from "../../../../utils/debounce";

const CanceledTransfers = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);

  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [hasMore, setHasMore] = useState(false);

  const fetchData = useCallback(async (StartDate, EndDate, page) => {
    try {
      setLoading(true);
      const { data } = await http.get(
        `api/inventorytransferrequest?status=Отменено&startDate=${StartDate}&endDate=${EndDate}&skip=${page}&pageSize=20`,
      );

      setHasMore(data.length === 20);
      setData(data);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchData(startDate, endDate, currentPage);
  }, [fetchData, startDate, endDate, currentPage]);

  const handleNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const handleStartDate = (e) => {
    debouncedSet(e.target.value, setStartDate);
  };

  const handleEndDate = (e) => {
    debouncedSet(e.target.value, setEndDate);
  };

  const handleRowClick = (record) => {
    setSelectedRowData(record);
    setIsModalVisible(true);
  };

  const closeViewModal = () => {
    setIsModalVisible(false);
    fetchData(startDate, endDate, 0);
  };

  const columns = [
    {
      title: t("numZakaz"),
      dataIndex: "docNum",
      key: "docNum",
      // ...getColumnSearchProps("docEntry"),
    },

    {
      title: t("date"),
      dataIndex: "docDate",
      key: "docDate",
    },

    {
      title: t("from-whs"),
      dataIndex: "fromWarehouseName",
      key: "fromWarehouseName",
    },

    {
      title: t("toWhs"),
      dataIndex: "toWarehouseName",
      key: "toWarehouseName",
    },
  ];

  return (
    <div className="flex w-full">
      <Menubar />
      <div className="h-screen w-full overflow-y-auto">
        <Header
          title={"canceledTransferRequests"}
          currentPage={currentPage + 1}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          hasMoreData={hasMore}
          columns={columns}
          fdata={data}
          loading={loading}
          handleRowClick={handleRowClick}
          onStartDateChange={handleStartDate}
          onEndDateChange={handleEndDate}
          startDate={startDate}
          endDate={endDate}
          formattedDate={moment().format("YYYY-MM-DD")}
        />
        <InventoryTransfersModal
          visible={isModalVisible}
          data={selectedRowData}
          onClose={closeViewModal}
          isShowReceivedQuantity={false}
          isShowGivingQuantity={false}
        />
      </div>
    </div>
  );
};

export default CanceledTransfers;
